var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({class:[_vm.cleanIcon ? 'clean-svg-icon' : 'svg-icon', _vm.className],style:(_vm.iconStyle),attrs:{"aria-hidden":"true"}},_vm.$listeners),[_c('use',{attrs:{"xlink:href":_vm.iconName,"fill":_vm.color}})])
}
var staticRenderFns = []

export { render, staticRenderFns }